import { useEffect, useRef, useState } from 'react';
import { AlertCircle, X } from 'lucide-react';
import { GLOBAL_ERROR_EVENT } from '../utils/errorDisplay';

export function GlobalErrorBanner() {
  const [message, setMessage] = useState('');
  const [visible, setVisible] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    const clearTimer = () => {
      if (!timerRef.current) return;
      clearTimeout(timerRef.current);
      timerRef.current = null;
    };

    const onErrorEvent = (event) => {
      const detail = event?.detail || {};
      const nextMessage = typeof detail.message === 'string' ? detail.message : 'Something went wrong. Please try again.';
      const duration = Number(detail.duration) > 0 ? Number(detail.duration) : 5000;

      clearTimer();
      setMessage(nextMessage);
      setVisible(true);
      timerRef.current = setTimeout(() => {
        setVisible(false);
      }, duration);
    };

    window.addEventListener(GLOBAL_ERROR_EVENT, onErrorEvent);
    return () => {
      clearTimer();
      window.removeEventListener(GLOBAL_ERROR_EVENT, onErrorEvent);
    };
  }, []);

  if (!visible || !message) return null;

  return (
    <div className="fixed left-1/2 top-4 z-[9999] w-[calc(100%-2rem)] max-w-3xl -translate-x-1/2 rounded-xl border border-[#E5B8B8] bg-[#FFF4F4] px-4 py-3 shadow-lg" role="alert" aria-live="assertive">
      <div className="flex items-start gap-3">
        <AlertCircle className="mt-0.5 h-5 w-5 flex-shrink-0 text-[#B42318]" />
        <p className="m-0 flex-1 text-sm font-medium text-[#B42318]">{message}</p>
        <button
          type="button"
          onClick={() => setVisible(false)}
          className="rounded p-1 text-[#B42318] hover:bg-[#FDE6E6]"
          aria-label="Dismiss error message"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
